import { useEffect } from "react";
import { useDispatch } from "react-redux";

/**
 * Custom hook to load data using useEffect.
 * @param loaded - The flag to check whether the requested data is loaded.
 * @param loading - The flag to check whether the requested data is still loading.
 * @param action - The action to perform.
 * @returns [expanded, handleChange] - The expanded panel state and a function to update it.
 */
export const useLoadOnce = (loaded: boolean, loading: boolean, action: () => any) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (!loaded && !loading) {
      dispatch(action());
    }
  }, [loaded, loading, dispatch]);
};
